const initialState = {
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GET_OVERDUE_CLIENTS':
      return {
        ...state,
        data: action.data,
      };
    default:
      return state;
  }
};
